import TagsInput from "react-tagsinput";
import React, { useState, useEffect } from "react";
import PubSub from "pubsub-js";
import Breadcrumbs from "../based/Breadcrumbs";
import { MAINMENU, CONSTANTS, NOTIFY } from "../based/Constants";
import { Layout } from "../layout/Layout";
import Loading from "../based/Loading";
import Textbox from "../based/inputs/Textbox";
import TextArea from "../based/inputs/TextArea";
import { Notify } from "../based/Notify";
import TFUImage from "../based/inputs/Image";
import useFormValidate from "../hooks/useFormValidate";
import TFUSelectSubdivisions from "../based/TFUSelectSubdivisions";
import WebSettingsServices from "../based/services/WebSettingsServices";
import Sticky from "react-stickynode";
import TextNumber from "../based/inputs/TextNumber";
import Common from "../based/Common";
import { useRef } from "react";
import Request from "../based/Request";
import QRCode from "react-qr-code";

const WebSetting = () => {
    const [loading, setLoading] = useState({ isLoading: false, msgLoading: "Đang tải dữ liệu..." });
    const [webSetting, setWebSetting] = useState({});
    const { addRef, isValid } = useFormValidate();
    const uploadRef = useRef(null);
    //đưa file .dst xuống thư viện mẫu cục bộ DesignServer - companyId/userName cố định (single-tenant), tên mẫu lấy từ tên file upload
    const DESIGN_SERVER_COMPANY_ID = 1;
    const DESIGN_SERVER_USER_NAME = "admin";
    const [designServerDrawing, setDesignServerDrawing] = useState({ drawingName: "", dstFileUrl: "", dstFileName: "" });
    const [isSubmittingDrawing, setIsSubmittingDrawing] = useState(false);
    const designServerUploadRef = useRef(null);
    //DrawingCode của mẫu vừa đưa vào DesignServer - hiện QR để bấm súng scan gắn ở máy A15 quét thẳng, không cần
    //mở DesignServer.exe tìm mẫu (QR chỉ encode đúng chuỗi DrawingCode, đã xác nhận qua tài liệu BECS-A15 mục 4.3)
    const [lastDrawingCode, setLastDrawingCode] = useState(null);

    useEffect(() => {
        getData();
        PubSub.publish(CONSTANTS.SIDEBAR_MENU_TOPIC, { mainMenu: MAINMENU.WebSetting });
    }, []);

    const getData = async () => {
        setLoading({ isLoading: true, msgLoading: "Đang tải dữ liệu..." });
        const [err, data] = await WebSettingsServices.GetWebSettings();
        if (!err && data) {
            setLoading({ isLoading: false });
            setWebSetting(data);
        } else {
            setWebSetting({});
            setLoading({ isLoading: false });
            if (err && err.message) Notify(NOTIFY.ERROR, "Lỗi", "Có lỗi: " + err.message);
        }
    };

    const handleInputChange = (name, value) => {
        webSetting[name] = value;
        setWebSetting({ ...webSetting });
    };

    const handleChangedImage = (name, url) => {
        webSetting[name] = url;
        setWebSetting({ ...webSetting });
    };

    const _handleUploadDesignServerDst = async (e) => {
        const input = e.target;
        let file = input.files[0];
        if (!file) return;
        setLoading({ isLoading: true, msgLoading: "Đang upload file .dst..." });
        let res = await Request.UploadDocument(file);
        setLoading({ isLoading: false });
        if (res && res.data) {
            //tên mẫu lấy từ tên file (bỏ phần đuôi .dst), giới hạn 32 ký tự theo cột drawing_name bên DesignServer
            const drawingName = file.name.replace(/\.[^/.]+$/, "").substring(0, 32);
            setDesignServerDrawing((prev) => ({ ...prev, dstFileUrl: res.data.url, dstFileName: file.name, drawingName }));
        } else {
            Notify(NOTIFY.ERROR, "Lỗi", "Upload file .dst thất bại");
        }
        input.value = "";
    };

    const _handleCreateDesignServerDrawing = async () => {
        if (!designServerDrawing.dstFileUrl || !designServerDrawing.drawingName) {
            Notify(NOTIFY.WARNING, "Thiếu thông tin", "Chọn file .dst trước khi đưa vào DesignServer");
            return;
        }
        setIsSubmittingDrawing(true);
        const [err, data] = await WebSettingsServices.CreateDesignServerDrawing({
            drawingName: designServerDrawing.drawingName,
            companyId: DESIGN_SERVER_COMPANY_ID,
            userName: DESIGN_SERVER_USER_NAME,
            dstFileUrl: designServerDrawing.dstFileUrl,
            dstFileName: designServerDrawing.dstFileName,
        });
        setIsSubmittingDrawing(false);
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, "Thành công", "Đã lên hàng đợi - worker cục bộ sẽ đưa file vào DesignServer");
            setLastDrawingCode(data.drawingCode || null);
            setDesignServerDrawing((prev) => ({ ...prev, drawingName: "", dstFileUrl: "", dstFileName: "" }));
        } else {
            Notify(NOTIFY.ERROR, "Có lỗi", "Không đưa được vào hàng đợi, vui lòng thử lại");
        }
    };

    const handleSave = async () => {
        if (isValid()) {
            setLoading({ isLoading: true, msgLoading: "Đang lưu dữ liệu..." });
            const [err, data] = await WebSettingsServices.SaveWebSettings(webSetting);
            if (!err && data) {
                setLoading({ isLoading: false });
                Notify(NOTIFY.SUCCESS, "Thành công", "Lưu thành công.");
            } else {
                setLoading({ isLoading: false });
                Notify(NOTIFY.WARNING, "Có lỗi", "Lưu thất bại.");
            }
        }
    };

    const handleUploadChange = (e) => {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];
        if (file) {
            reader.onloadend = () => {
                setLoading({ isLoading: true, msgLoading: "Đang convert file..." });
                Request.Convert(file).then((res) => {
                    let resultFileName = res && res.data && res.data.resultFileName;
                    if (resultFileName) {
                        pollConvertEmbroiStatus(resultFileName);
                    } else {
                        setLoading({ isLoading: false });
                        Notify(NOTIFY.WARNING, "Có lỗi", (res && res.message) || "Không thể convert file.");
                    }
                });
            };
            reader.readAsDataURL(file);
        }
    };

    const pollConvertEmbroiStatus = (resultFileName) => {
        const maxAttempts = 30; //30 lần x 2s = tối đa 60s chờ convert
        let attempts = 0;
        const intervalId = setInterval(() => {
            attempts++;
            Request.CheckConvertEmbroiStatus(resultFileName).then((res) => {
                if (res && res.data && res.data.done) {
                    clearInterval(intervalId);
                    setLoading({ isLoading: false });
                    window.location.href = res.data.fileResultUrl;
                } else if (attempts >= maxAttempts) {
                    clearInterval(intervalId);
                    setLoading({ isLoading: false });
                    Notify(NOTIFY.WARNING, "Có lỗi", "Convert file quá thời gian chờ, vui lòng thử lại.");
                }
            });
        }, 2000);
    };

    return (
        <React.Fragment>
            <Breadcrumbs currentPage=" Cấu hình Website" />
            <Loading show={loading.isLoading} msg={loading.msgLoading} />
            <Sticky enabled={true} top={70} bottomBoundary={4000} innerZ={2}>
                <div className="form-group text-right product-navigate-buttons">
                    <button type="button" className="btn btn-custom waves-effect w-xs waves-light btn-sm" onClick={() => handleSave()}>
                        <i className="fa fa-save m-r-5"></i> Lưu cấu hình
                    </button>
                </div>
            </Sticky>
            <div className="row">
                <div className="col-sm-12 pr-1">
                    <div className="card-box p-3">
                        <div className="form-group form-row">
                            <div className="col-md-6">
                                <label htmlFor="title">Title:</label>
                                <Textbox ref={addRef} id="title" name="title" className="form-control" value={webSetting.title} onChanged={handleInputChange} />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="keywords">Keywords:</label>
                                <Textbox ref={addRef} id="keywords" name="keywords" className="form-control" value={webSetting.keywords} onChanged={handleInputChange} />
                            </div>
                        </div>
                        <div className="form-group form-row">
                            <div className="col-md-6">
                                <label htmlFor="ogSiteName">Og SiteName:</label>
                                <Textbox ref={addRef} id="ogSiteName" name="ogSiteName" className="form-control" value={webSetting.ogSiteName} onChanged={handleInputChange} />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="ogUrl">Og Url:</label>
                                <Textbox ref={addRef} id="ogUrl" name="ogUrl" className="form-control" value={webSetting.ogUrl} onChanged={handleInputChange} />
                            </div>
                        </div>
                        <div className="form-group form-row">
                            <div className="col-md-6">
                                <label htmlFor="ogTitle">Og Title:</label>
                                <Textbox ref={addRef} id="ogTitle" name="ogTitle" className="form-control" value={webSetting.ogTitle} onChanged={handleInputChange} />
                            </div>
                        </div>
                        <div className="form-group form-row">
                            <div className="col-md-6">
                                <label htmlFor="description">Description:</label>
                                <TextArea ref={addRef} id="description" name="description" className="form-control" value={webSetting.description} onChanged={handleInputChange} />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="ogDescription">Og Description:</label>
                                <TextArea ref={addRef} id="ogDescription" name="ogDescription" className="form-control" value={webSetting.ogDescription} onChanged={handleInputChange} />
                            </div>
                        </div>
                        <div className="form-group form-row">
                            <div className="col-md-6">
                                <label htmlFor="facebookUrl">Facebook Url:</label>
                                <Textbox ref={addRef} id="facebookUrl" name="facebookUrl" className="form-control" value={webSetting.facebookUrl} onChanged={handleInputChange} />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="twitterUrl">Twitter Url:</label>
                                <Textbox ref={addRef} id="twitterUrl" name="twitterUrl" className="form-control" value={webSetting.twitterUrl} onChanged={handleInputChange} />
                            </div>
                        </div>
                        <div className="form-group form-row">
                            <div className="col-md-6">
                                <label htmlFor="googleUrl">Google Url:</label>
                                <Textbox ref={addRef} id="googleUrl" name="googleUrl" className="form-control" value={webSetting.googleUrl} onChanged={handleInputChange} />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="instagramUrl">Instagram Url:</label>
                                <Textbox ref={addRef} id="instagramUrl" name="instagramUrl" className="form-control" value={webSetting.instagramUrl} onChanged={handleInputChange} />
                            </div>
                        </div>
                        <div className="form-group form-row">
                            <div className="col-md-6">
                                <label htmlFor="rssUrl">Rss Url:</label>
                                <Textbox ref={addRef} id="rssUrl" name="rssUrl" className="form-control" value={webSetting.rssUrl} onChanged={handleInputChange} />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="phoneNumber">Phone Number:</label>
                                <Textbox ref={addRef} id="phoneNumber" name="phoneNumber" className="form-control" value={webSetting.phoneNumber} onChanged={handleInputChange} />
                            </div>
                        </div>
                        <div className="form-group form-row">
                            <div className="col-md-6">
                                <label htmlFor="fax">Fax:</label>
                                <Textbox ref={addRef} id="fax" name="fax" className="form-control" value={webSetting.fax} onChanged={handleInputChange} />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="email">Email:</label>
                                <Textbox ref={addRef} id="email" name="email" className="form-control" email value={webSetting.email} onChanged={handleInputChange} />
                            </div>
                        </div>
                        <TFUSelectSubdivisions
                            showProvince
                            showDistrict
                            showWard
                            provinceInputName="provinceCode"
                            districtInputName="districtCode"
                            wardInputName="wardCode"
                            provinceCode={webSetting.provinceCode}
                            districtCode={webSetting.districtCode}
                            wardCode={webSetting.wardCode}
                            onChanged={(obj) => setWebSetting({ ...webSetting, provinceCode: obj.provinceCode, districtCode: obj.districtCode, wardCode: obj.wardCode })}
                            addRef={addRef}
                            parentClassName="form-row"
                            childClassName="form-group col-md-6"
                        />
                        <div className="form-group form-row">
                            <div className="col-md-6">
                                <label htmlFor="address">Address:</label>
                                <Textbox ref={addRef} id="address" name="address" className="form-control" value={webSetting.address} onChanged={handleInputChange} />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="campaignBoostingLoyalty">Giá Loyalty Boosting</label>
                                <TextNumber name="campaignBoostingLoyalty" suffix="đồng" className="form-control" value={webSetting.campaignBoostingLoyalty} onChanged={handleInputChange} />
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="logo">Logo:</label>
                            <div className="bg-white">
                                <TFUImage image={webSetting.logo} onChanged={handleChangedImage} name="logo" />
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="favicon">Favicon:</label>
                            <div className="bg-white">
                                <TFUImage image={webSetting.favicon} onChanged={handleChangedImage} name="favicon" />
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="ogImage">Og Image:</label>
                            <div className="bg-white">
                                <TFUImage image={webSetting.ogImage} onChanged={handleChangedImage} name="ogImage" />
                            </div>
                        </div>
                        <div className="form-group form-row">
                            <div className="col-md-6">
                                <label htmlFor="preventKeyword">Danh sách Keyword loại bỏ theo GOV:</label>
                                <TextArea ref={addRef} id="preventKeyword" name="preventKeyword" className="form-control" value={webSetting.preventKeyword} onChanged={handleInputChange} />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="tagTrending">Danh sách Tag Trending</label>
                                <TagsInput
                                    addKeys={[13]}
                                    addOnPaste
                                    maxTags={10}
                                    inputProps={{ placeholder: "" }}
                                    value={webSetting.tagTrending || []}
                                    onChange={(tags) => {
                                        let newTags = tags.reduce((prev, val, idx) => {
                                            let value = Common.removeVietnameseFromString(val);
                                            value = `#${value.replace(/ /g, "")}`;
                                            return prev.indexOf(value) == -1 ? [...prev, value] : [...prev];
                                        }, []);
                                        setWebSetting({ ...webSetting, tagTrending: newTags });
                                    }}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="form-group col-md-6">
                                <label htmlFor="googleAnalytics">Xử lý PES/CSV:</label>
                                <button
                                    onClick={(e) => {
                                        e.preventDefault();
                                        uploadRef?.current?.click();
                                    }}
                                >
                                    Upload File
                                </button>

                                <input
                                    type={"file"}
                                    className="form-control d-none"
                                    ref={uploadRef}
                                    onChange={(e) => {
                                        handleUploadChange(e);
                                    }}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="form-group col-md-12">
                                <label>Đẩy file .dst xuống DesignServer (thư viện mẫu cục bộ máy thêu):</label>
                            </div>
                            <div className="form-group col-md-4">
                                <label>File .dst:</label>
                                <div>
                                    <button
                                        type="button"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            designServerUploadRef?.current?.click();
                                        }}
                                    >
                                        {designServerDrawing.dstFileName || "Chọn file .dst"}
                                    </button>
                                    <input
                                        type="file"
                                        accept=".dst"
                                        className="form-control d-none"
                                        ref={designServerUploadRef}
                                        onChange={_handleUploadDesignServerDst}
                                    />
                                </div>
                                {designServerDrawing.drawingName && <small className="text-muted">Tên mẫu: {designServerDrawing.drawingName}</small>}
                            </div>
                            <div className="form-group col-md-12">
                                <button
                                    type="button"
                                    className="btn btn-custom waves-effect w-xs waves-light btn-sm"
                                    disabled={isSubmittingDrawing || !designServerDrawing.dstFileUrl || !designServerDrawing.drawingName}
                                    onClick={_handleCreateDesignServerDrawing}
                                >
                                    <i className="fa fa-upload m-r-5"></i> Đưa vào DesignServer
                                </button>
                            </div>
                            {lastDrawingCode && (
                                <div className="form-group col-md-12">
                                    <label>Quét mã này bằng súng scan gắn ở máy A15 để nhận mẫu ngay (không cần mở DesignServer trên PC):</label>
                                    <div style={{ background: "#fff", padding: 16, width: "fit-content" }}>
                                        <QRCode value={lastDrawingCode} size={160} />
                                    </div>
                                    <small className="text-muted">Mã: {lastDrawingCode}</small>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default WebSetting;
